/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Next ID: 66
 */
export enum OdProtosCommonState_State {
  AA = 'AA',
  AE = 'AE',
  AK = 'AK',
  AL = 'AL',
  AP = 'AP',
  AR = 'AR',
  AS = 'AS',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DC = 'DC',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  GU = 'GU',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  PR = 'PR',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UNKNOWN = 'UNKNOWN',
  UT = 'UT',
  VA = 'VA',
  VI = 'VI',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY',
}

/**
 * Next ID: 13
 */
export enum OdProtosTrippyData_VisitOrdering_Column {
  ADDRESS_ID = 'ADDRESS_ID',
  ASSIGNED_ORGANIZATION_ID = 'ASSIGNED_ORGANIZATION_ID',
  ASSIGNED_USER_TOKEN = 'ASSIGNED_USER_TOKEN',
  CANCELLED_AT = 'CANCELLED_AT',
  CHECK_IN_AT = 'CHECK_IN_AT',
  CHECK_OUT_AT = 'CHECK_OUT_AT',
  CREATED_AT = 'CREATED_AT',
  DUE_BY = 'DUE_BY',
  SCHEDULE_START_AT = 'SCHEDULE_START_AT',
  SCHEDULE_STOP_AT = 'SCHEDULE_STOP_AT',
  UPDATED_AT = 'UPDATED_AT',
  VISIT_TYPE_ID = 'VISIT_TYPE_ID',
}

/**
 * Next ID: 42
 * NOTE: When you update this, please also create a migration to update dwh_capabilities_view
 */
export enum OdProtosVendorsData_CapabilityType {
  AGENT = 'AGENT',
  APPLIANCE = 'APPLIANCE',
  BRN_AND_LRR = 'BRN_AND_LRR',
  BROKER = 'BROKER',
  CARPET_CLEANING = 'CARPET_CLEANING',
  CHIMNEY = 'CHIMNEY',
  CLEANING = 'CLEANING',
  DATA_LABELING = 'DATA_LABELING',
  DAY_ONE_WALK = 'DAY_ONE_WALK',
  DISPATCH = 'DISPATCH',
  ELECTRICAL = 'ELECTRICAL',
  ENGINEERING = 'ENGINEERING',
  FENCING = 'FENCING',
  FLOORING = 'FLOORING',
  FOUNDATION = 'FOUNDATION',
  GARAGE_DOOR = 'GARAGE_DOOR',
  GENERAL_CONTRACTOR = 'GENERAL_CONTRACTOR',
  GENERAL_INSPECTOR = 'GENERAL_INSPECTOR',
  GLASS_WINDOW = 'GLASS_WINDOW',
  GUTTERS = 'GUTTERS',
  HANDYMAN = 'HANDYMAN',
  HOME_ASSESSMENT = 'HOME_ASSESSMENT',
  HVAC = 'HVAC',
  IRRIGATION = 'IRRIGATION',
  JUNK_REMOVAL = 'JUNK_REMOVAL',
  LANDSCAPING = 'LANDSCAPING',
  LAND_SURVEYING = 'LAND_SURVEYING',
  LIVING_AREA_MEASUREMENT = 'LIVING_AREA_MEASUREMENT',
  LOCKSMITH = 'LOCKSMITH',
  MASONRY = 'MASONRY',
  MOLD_REMEDIATION = 'MOLD_REMEDIATION',
  ODOR_REMEDIATION = 'ODOR_REMEDIATION',
  OIL_TANK_SERVICES = 'OIL_TANK_SERVICES',
  PAINTING = 'PAINTING',
  PESTS = 'PESTS',
  PHOTOGRAPHY = 'PHOTOGRAPHY',
  PLUMBING = 'PLUMBING',
  POOL = 'POOL',
  PRESSURE_WASHING = 'PRESSURE_WASHING',
  RADON_TESTING = 'RADON_TESTING',
  REHAB_GENERAL_CONTRACTOR = 'REHAB_GENERAL_CONTRACTOR',
  RESTORATION = 'RESTORATION',
  RESURFACING = 'RESURFACING',
  ROOF = 'ROOF',
  SECURITY = 'SECURITY',
  SEPTIC_AND_SEWER = 'SEPTIC_AND_SEWER',
  SNOW = 'SNOW',
  STRUCTURAL = 'STRUCTURAL',
  VALUATIONS = 'VALUATIONS',
  WELLS = 'WELLS',
}

/**
 * Next ID: 2
 * NOTE: When you update this, please also create a migration to update dwh_compliance_view
 */
export enum OdProtosVendorsData_ComplianceStatus {
  COMPLIANT = 'COMPLIANT',
  NOT_COMPLIANT = 'NOT_COMPLIANT',
}

/**
 * Next ID: 3
 * NOTE: When you update this, please also create a migration to update dwh_branches_view
 */
export enum OdProtosVendorsData_Status {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  PENDING = 'PENDING',
}

export enum OdProtosWebData_MaintenanceRequest_FrequencyKind {
  DAY = 'DAY',
  MONTH = 'MONTH',
  ONE_OFF = 'ONE_OFF',
  WEEK = 'WEEK',
}

export enum OdProtosWebData_MaintenanceRequest_Kind {
  CLEANING = 'CLEANING',
  HVAC = 'HVAC',
  LANDSCAPING = 'LANDSCAPING',
  NONE = 'NONE',
  OTHER = 'OTHER',
  POOL = 'POOL',
  SNOW = 'SNOW',
}

export enum OdProtosWebData_MaintenanceRequest_State {
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  DENIED = 'DENIED',
  INVALID = 'INVALID',
  INVOICED = 'INVOICED',
  MISSED = 'MISSED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  PENDING = 'PENDING',
}

/**
 * Pagination request.
 *
 * To enable forward pagination, two arguments are required.
 * * first takes a non‐negative integer.
 * * after takes the cursor type as described in the cursor field section.
 * The server should use those two arguments to modify the edges returned by
 * the connection, returning edges after the after cursor, and returning at
 * most first edges.
 *
 * To enable backward pagination, two arguments are required.
 * * last takes a non‐negative integer.
 * * before takes the cursor type as described in the cursor field section.
 * The server should use those two arguments to modify the edges returned by
 * the connection, returning edges before the before cursor, and returning at
 * most last edges.
 */
export interface OdProtosCommonPagination_PaginationRequestInput {
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
}

export interface OdProtosCommon_DateInput {
  year?: number | null;
  month?: number | null;
  day?: number | null;
}

/**
 * Next ID: 3
 */
export interface OdProtosTrippyData_VisitOrderingInput {
  column?: OdProtosTrippyData_VisitOrdering_Column | null;
  isDescending?: boolean | null;
}

export interface OdProtosTrippyServices_TimestampParamInput {
  params?: OdProtosTrippyServices_TimestampParam_ParamsOneofInput | null;
}

export interface OdProtosTrippyServices_TimestampParam_ParamsOneofInput {
  unset?: boolean | null;
  timeRange?: OdProtosTrippyServices_TimestampRangeInput | null;
}

export interface OdProtosTrippyServices_TimestampRangeInput {
  start?: GQLDateTime | null;
  end?: GQLDateTime | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
